import About from "../About";
import Skills from "../Skills";

function Home({ name, title, imageUrl, bio, skills }) {
  return (
    <>
      <About name={name} title={title} imageUrl={imageUrl} bio={bio} />
      <Skills skills={skills} />
    </>
  );
}

export default Home;
